import { isMac } from "../platformUtils";

export const runShortcut = `${isMac() ? "⌘" : "Ctrl-"}⏎`;
export const saveShortcut = `${isMac() ? "⌘" : "Ctrl-"}S`;
